var ShowDataInputComponent = /** @class */ (function () {
    function ShowDataInputComponent() {
        this.iconSize = 'normal';
    }
    return ShowDataInputComponent;
}());
export { ShowDataInputComponent };
